module.exports = __webpack_public_path__ + "media/images/emblems/Luescherz-coat_of_arms-2c07f1e913fdf4fa4ec3ab627768d0e7.svg";